<template>
  <div>
    <PageTitle :route="$route">
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <ArenaSettingsList />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
  import PageTitle from '@/components/layout/PageTitle'
  import PageRowWrapper from '@/components/layout/PageRowWrapper'
  import ArenaSettingsList from '@/components/settings/ArenaSettingsList'

  export default {
    name: 'Settings',
    components: {
      PageTitle,
      PageRowWrapper,
      ArenaSettingsList
    }
  }
</script>
